/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-restricted-globals */
import React, { memo, useState, useEffect, useCallback } from 'react';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import Title from '@wconcept/wconcept-ui-renewal/components/atoms/Title';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import Input from '@wconcept/wconcept-ui-renewal/components/atoms/Input';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Slider, Rail, Handles, Tracks } from 'react-compound-slider';
import Handle from './Handle';
import Track from './Track';
import { normalizeSliderRange } from './range';
import * as S from './style';

interface IProps {
  title?: string;
  subTitle?: string;
  domain?: number[];
  values?: number[];
  step?: number;
  children?: React.ReactNode;
  onValues?: (values: number[]) => void;
}

const FltPriceBox = ({
  title,
  subTitle,
  domain = [0, 100],
  values = [0, 100],
  step = 1000,
  onValues,
}: IProps) => {
  const [domainMin, domainMax] = domain;
  const [valueMin, valueMax] = values;
  const [$domain, setDomain] = useState<[number, number]>(
    () => normalizeSliderRange(domain, values).domain
  );
  const [$values, setValues] = useState<[number, number]>(
    () => normalizeSliderRange(domain, values).values
  );
  const [$valuesInp, setValuesInp] = useState<string[]>([]);
  const [inputBoxClassName, setInputBoxClassName] = useState('');
  const [isSlidding, setIsSlidding] = useState<boolean>(false);

  const updateInput = useCallback(
    (result: number[]) => {
      setInputBoxClassName(
        classNameBind([$domain[1] === result[1] ? 'isOver' : ''])
      );
      setValuesInp([
        result[0]?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
        result[1]?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
      ]);
    },
    [$domain]
  );

  useEffect(() => {
    const nextRange = normalizeSliderRange(
      [domainMin, domainMax],
      [valueMin, valueMax]
    );

    setDomain(previous =>
      previous[0] === nextRange.domain[0] && previous[1] === nextRange.domain[1]
        ? previous
        : nextRange.domain
    );
    setValues(previous =>
      previous[0] === nextRange.values[0] && previous[1] === nextRange.values[1]
        ? previous
        : nextRange.values
    );
    updateInput(nextRange.values);
  }, [domainMax, domainMin, updateInput, valueMax, valueMin]);

  useEffect(() => {
    if (isSlidding) {
      updateInput($values);
    }
  }, [$values, isSlidding, updateInput]);

  const onSliderStart = useCallback(() => {
    setIsSlidding(true);
  }, []);

  // ITEM HANDLER : onSlider
  const onSlider = useCallback(
    (values: readonly number[]) => {
      setIsSlidding(false);
      const min = isNaN(values[0]) ? $domain[0] : values[0];
      const max = isNaN(values[1]) ? $domain[1] : values[1];
      const result: [number, number] = [min, max];
      setValues(result);
      // updateInput(result);
      onValues && onValues(result);
    },
    [$domain, onValues]
  );

  const onSliderChange = useCallback(
    (values: readonly number[]) => {
      if (isSlidding) {
        const min = isNaN(values[0]) ? $domain[0] : values[0];
        const max = isNaN(values[1]) ? $domain[1] : values[1];
        const result: [number, number] = [min, max];
        setValues(result);
        // updateInput(result);
      }
    },
    [$domain, isSlidding]
  );

  // ITEM HANDLER : onFocusMin
  const onFocusMin = (e: React.FocusEvent<HTMLInputElement>) => {
    setValuesInp([
      $values[0]?.toString().replace(/[^\d]+/g, ''),
      $values[1]?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
    ]);
  };

  // ITEM HANDLER : onFocusMax
  const onFocusMax = (e: React.FocusEvent<HTMLInputElement>) => {
    setValuesInp([
      $values[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
      $values[1].toString().replace(/[^\d]+/g, ''),
    ]);
  };

  // ITEM HANDLER : onEventMin
  const onEventMin = (
    e:
      | React.FocusEvent<HTMLInputElement>
      | React.KeyboardEvent<HTMLInputElement>
  ) => {
    const minValue = (e.target as HTMLInputElement).value;
    const v: number =
      Math.round(parseInt(minValue?.replace(/,/g, ''), 10) / 1000) * 1000;
    const values: number[] = [
      v < $domain[0] ? $domain[0] : v > $domain[1] ? $domain[1] : v,
      $values[1],
    ].sort((a, b) => a - b);
    setValuesInp([String(values[0]), String(values[1])]);
    const min = isNaN(values[0]) ? $domain[0] : values[0];
    const max = isNaN(values[1]) ? $domain[1] : values[1];
    const result: [number, number] = [min, max];
    setValues(result);
    onValues && onValues(result);
  };

  // ITEM HANDLER : onEventMax
  const onEventMax = (
    e:
      | React.FocusEvent<HTMLInputElement>
      | React.KeyboardEvent<HTMLInputElement>
  ) => {
    const input = e.target as HTMLInputElement;
    const v: number =
      Math.round(parseInt(input.value.replace(/,/g, ''), 10) / 1000) * 1000;
    const values: number[] = [
      $values[0],
      v > $domain[1] ? $domain[1] : v < $domain[0] ? $domain[0] : v,
    ].sort((a, b) => a - b);
    // console.log('onEventMax values => ', values);
    setValuesInp([String(values[0]), String(values[1])]);
    const min = isNaN(values[0]) ? $domain[0] : values[0];
    const max = isNaN(values[1]) ? $domain[1] : values[1];
    const result: [number, number] = [min, max];
    setValues(result);
    onValues && onValues(result);
  };

  return (
    <>
      <S.TitleBox>
        <Title level={4}>
          <Text>{title}</Text>
        </Title>
        <Text className="sub-title">{subTitle}</Text>
      </S.TitleBox>
      <S.InputBox className={`area-inp ${inputBoxClassName}`}>
        <Input
          value={$valuesInp[0]}
          pattern="[0-9]*"
          inputMode="numeric"
          suffix="원"
          onFocus={onFocusMin}
          onBlur={onEventMin}
          onPressEnter={onEventMin}
        />
        <span className="between">~</span>
        <Input
          value={$valuesInp[1]}
          pattern="[0-9]*"
          inputMode="numeric"
          suffix="원"
          onFocus={onFocusMax}
          onBlur={onEventMax}
          onPressEnter={onEventMax}
        />
        <span className="over">+</span>
      </S.InputBox>
      <S.SliderBox>
        <Slider
          mode={1}
          step={step}
          domain={$domain}
          onSlideStart={onSliderStart}
          onUpdate={onSliderChange}
          onSlideEnd={onSlider}
          values={$values}
          className="slider"
        >
          <Rail>
            {({ getRailProps }) => <div className="rail" {...getRailProps()} />}
          </Rail>
          <Handles>
            {({ handles, getHandleProps }) => (
              <div className="slider-handles">
                {handles.map(handle => (
                  <Handle
                    key={handle.id}
                    handle={handle}
                    getHandleProps={getHandleProps}
                  />
                ))}
              </div>
            )}
          </Handles>
          <Tracks left={false} right={false}>
            {({ tracks, getTrackProps }) => (
              <div className="slider-tracks">
                {tracks.map(({ id, source, target }) => (
                  <Track
                    key={id}
                    source={source}
                    target={target}
                    getTrackProps={getTrackProps}
                  />
                ))}
              </div>
            )}
          </Tracks>
        </Slider>
      </S.SliderBox>
    </>
  );
};

export default memo(FltPriceBox);
